import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectAllNodes, selectAllPoints } from '../map/slice/mapSelectors';
import { useFitMap } from '../plotter/usePanMap';

export const useFocusTSP = () => {
  const fitMap = useFitMap();
  const dispatch = useDispatch();

  const points = useSelector(selectAllPoints);
  const nodes = useSelector(selectAllNodes);

  const focusTSP = useCallback(
    (tspId: string | number | null | undefined) => {
      if (!tspId) {
        return false;
      }
      const tspNodes = Object.values(points)
        .filter((point) => point.tsp_id === tspId)
        .map((point) => {
          return nodes[point?.node ?? ''];
        })
        .filter((node) => node !== undefined);

      if (tspNodes.length === 0) {
        return false;
      }

      fitMap(tspNodes);
      return true;
    },
    [dispatch, nodes, fitMap, points],
  );

  return focusTSP;
};
